module.exports = __webpack_public_path__ + "static/media/HowItWorks.51819dbc.png";